(function () {
  var GROUPS = ['condition', 'animal', 'type', 'season'];
  var PREFIX = { animal: 'Animal_', type: 'Type_', condition: 'Condition_', season: 'Season_' };

  function init(root) {
    if (!root || root.getAttribute('data-vm-blog-ready')) return;
    root.setAttribute('data-vm-blog-ready', 'true');

    var cfg = {
      sectionId: root.getAttribute('data-section-id'),
      base: root.getAttribute('data-base-url'),
      pages: parseInt(root.getAttribute('data-pages'), 10) || 1,
      maxPages: parseInt(root.getAttribute('data-max-pages'), 10) || 10,
      perPage: parseInt(root.getAttribute('data-per-page'), 10) || 12,
      currentTags: (root.getAttribute('data-current-tags') || '').split('|').filter(Boolean),
      featured: root.getAttribute('data-featured') || '',
      one: root.getAttribute('data-singular') || 'article',
      many: root.getAttribute('data-plural') || 'articles'
    };

    var labels = {};
    try { labels = JSON.parse(root.querySelector('[data-vm-blog-labels]').textContent); } catch (err) {}
    var buttons = root.querySelectorAll('[data-vm-blog-filter]');
    buttons.forEach(function (b) { labels[b.getAttribute('data-tag')] = b.getAttribute('data-label'); });
    function labelFor(tag) { return labels[tag] || tag.replace(/^[^_]+_/, '').replace(/_/g, ' '); }

    var list = root.querySelector('[data-vm-blog-list]');
    var heading = root.querySelector('[data-vm-blog-heading]');
    var status = root.querySelector('[data-vm-blog-status]');
    var applied = root.querySelector('[data-vm-blog-applied]');
    var chipsEl = root.querySelector('[data-vm-blog-chips]');
    var emptyEl = root.querySelector('[data-vm-blog-empty]');
    var moreWrap = root.querySelector('[data-vm-blog-more-wrap]');
    var moreBtn = root.querySelector('[data-vm-blog-more]');
    var sortBtns = root.querySelectorAll('[data-vm-blog-sort]');
    var resetBtn = root.querySelector('.vm-blog-results__reset');
    var track = root.querySelector('[data-vm-blog-track]');
    var progress = root.querySelector('[data-vm-blog-progress]');
    var thumb = root.querySelector('[data-vm-blog-thumb]');
    var pager = root.querySelector('[data-vm-blog-pager]');
    var panel = root.querySelector('[data-vm-blog-panel]');
    var toggle = root.querySelector('[data-vm-blog-toggle]');
    var activeBadge = root.querySelector('[data-vm-blog-active]');
    var activeN = root.querySelector('[data-vm-blog-active-n]');
    var applyBtn = root.querySelector('[data-vm-blog-apply]');
    var clearMobile = root.querySelector('[data-vm-blog-clear-m]');
    var bar = root.querySelector('.vm-blog-results__bar');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (pager) pager.hidden = true;

    var state = { condition: [], animal: [], type: [], season: [], q: '', sort: 'newest' };
    var items = [];
    var seen = {};
    var shown = cfg.perPage;

    function groupOf(tag) {
      for (var g in PREFIX) { if (tag.indexOf(PREFIX[g]) === 0) return g; }
      return null;
    }
    function norm(t) { return String(t || '').trim().toLowerCase(); }
    function hasTag(it, t) {
      t = norm(t);
      if (!t) return false;
      for (var i = 0; i < it.low.length; i++) {
        var tag = it.low[i];
        if (tag === t || tag.slice(tag.indexOf('_') + 1) === t) return true;
      }
      return false;
    }
    function readItem(el) {
      var tags = (el.getAttribute('data-tags') || '').split('|').filter(Boolean);
      return {
        el: el,
        tags: tags,
        low: tags.map(norm),
        text: (el.getAttribute('data-search') || '').toLowerCase(),
        title: (el.getAttribute('data-title') || '').toLowerCase(),
        date: el.getAttribute('data-date') || ''
      };
    }
    function addItems(nodes) {
      Array.prototype.forEach.call(nodes, function (node) {
        var id = node.getAttribute('data-id');
        if (seen[id]) return;
        seen[id] = true;
        var el = node.ownerDocument === document ? node : document.importNode(node, true);
        if (el.parentNode !== list) list.appendChild(el);
        items.push(readItem(el));
      });
    }
    function activeCount() {
      var n = state.q ? 1 : 0;
      GROUPS.forEach(function (g) { n += state[g].length; });
      return n;
    }
    function anyActive() { return activeCount() > 0; }
    function matches(it, skip) {
      for (var i = 0; i < GROUPS.length; i++) {
        var g = GROUPS[i];
        if (g === skip) continue;
        var sel = state[g];
        if (sel.length && !sel.some(function (t) { return hasTag(it, t); })) return false;
      }
      if (state.q) {
        var words = state.q.toLowerCase().split(/\s+/).filter(Boolean);
        for (var w = 0; w < words.length; w++) {
          if (it.text.indexOf(words[w]) === -1) return false;
        }
      }
      return true;
    }
    function sortItems(arr) {
      var a = arr.slice();
      if (state.sort === 'az') {
        a.sort(function (x, y) { return x.title.localeCompare(y.title); });
      } else {
        var dir = state.sort === 'oldest' ? 1 : -1;
        a.sort(function (x, y) { return x.date < y.date ? -dir : x.date > y.date ? dir : 0; });
      }
      return a;
    }
    function plural(n) { return n + ' ' + (n === 1 ? cfg.one : cfg.many); }
    function facetCount(group, tag) {
      var n = 0;
      items.forEach(function (it) { if (hasTag(it, tag) && matches(it, group)) n++; });
      return n;
    }

    function makeChip(text, aria, onRemove) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'vm-blog-results__chip';
      b.setAttribute('aria-label', aria);
      b.innerHTML = '<span></span><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>';
      b.firstChild.textContent = text;
      b.addEventListener('click', onRemove);
      return b;
    }

    function renderControls() {
      buttons.forEach(function (b) {
        var g = b.getAttribute('data-group');
        var tag = b.getAttribute('data-tag');
        var on = state[g].indexOf(tag) > -1;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var c = b.querySelector('[data-count]');
        if (c) {
          var n = facetCount(g, tag);
          c.textContent = items.length ? (b.classList.contains('vm-blog-results__tile') ? plural(n) : n) : '';
          b.disabled = !!items.length && n === 0 && !on && !(window.Shopify && window.Shopify.designMode);
        }
      });
      sortBtns.forEach(function (sb) {
        sb.setAttribute('aria-pressed', sb.getAttribute('data-vm-blog-sort') === state.sort ? 'true' : 'false');
      });

      chipsEl.innerHTML = '';
      GROUPS.forEach(function (g) {
        state[g].forEach(function (tag) {
          chipsEl.appendChild(makeChip(labelFor(tag), 'Remove filter: ' + labelFor(tag), function () {
            state[g] = state[g].filter(function (t) { return t !== tag; });
            update();
          }));
        });
      });
      if (state.q) {
        chipsEl.appendChild(makeChip('\u201C' + state.q + '\u201D', 'Clear search: ' + state.q, function () {
          state.q = '';
          update();
        }));
      }
      var count = activeCount();
      applied.hidden = count === 0;
      if (resetBtn) resetBtn.disabled = count === 0;
      if (activeBadge) {
        activeBadge.hidden = count === 0;
        activeN.textContent = count;
      }
      if (clearMobile) clearMobile.disabled = count === 0;
    }

    function render() {
      var active = anyActive();
      var res = sortItems(items.filter(function (it) { return matches(it); }));
      var pinned = null;
      if (cfg.featured && !active) {
        var tagged = items.filter(function (it) { return hasTag(it, cfg.featured); });
        tagged.sort(function (x, y) { return x.date < y.date ? 1 : x.date > y.date ? -1 : 0; });
        pinned = tagged[0] || null;
        if (pinned) res = [pinned].concat(res.filter(function (it) { return it !== pinned; }));
      }
      items.forEach(function (it) {
        it.el.hidden = true;
        it.el.classList.remove('is-featured');
        var p = it.el.querySelector('[data-featured-pill]');
        if (p) p.hidden = true;
      });
      res.forEach(function (it, i) {
        list.appendChild(it.el);
        it.el.hidden = i >= shown;
      });
      if (pinned) {
        pinned.el.classList.add('is-featured');
        var pill = pinned.el.querySelector('[data-featured-pill]');
        if (pill) pill.hidden = false;
      }

      heading.textContent = plural(res.length);
      status.textContent = plural(res.length);
      if (applyBtn) applyBtn.textContent = 'Show ' + plural(res.length);
      emptyEl.hidden = res.length > 0;
      moreWrap.hidden = res.length <= shown;
      renderControls();

      window.dispatchEvent(new CustomEvent('vm-blog:change', {
        detail: {
          condition: state.condition.slice(),
          animal: state.animal.slice(),
          type: state.type.slice(),
          season: state.season.slice(),
          q: state.q,
          sort: state.sort
        }
      }));
    }

    function writeUrl() {
      if (window.Shopify && window.Shopify.designMode) return;
      var params = new URLSearchParams();
      GROUPS.forEach(function (g) { if (state[g].length) params.set(g, state[g].join(',')); });
      if (state.q) params.set('q', state.q);
      if (state.sort !== 'newest') params.set('sort', state.sort);
      var qs = params.toString();
      history.replaceState(null, '', cfg.base + (qs ? '?' + qs : ''));
    }

    function update() {
      shown = cfg.perPage;
      render();
      writeUrl();
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        var g = b.getAttribute('data-group');
        var tag = b.getAttribute('data-tag');
        if (state[g].indexOf(tag) > -1) state[g] = state[g].filter(function (t) { return t !== tag; });
        else state[g] = state[g].concat([tag]);
        update();
      });
    });

    root.querySelectorAll('[data-vm-blog-clear]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        GROUPS.forEach(function (g) { state[g] = []; });
        state.q = '';
        update();
      });
    });

    sortBtns.forEach(function (sb) {
      sb.addEventListener('click', function () {
        state.sort = sb.getAttribute('data-vm-blog-sort');
        update();
      });
    });

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        var before = shown;
        shown += cfg.perPage;
        render();
        var visible = Array.prototype.filter.call(list.children, function (el) { return !el.hidden; });
        var next = visible[before];
        if (next) {
          var link = next.querySelector('.vm-blog-card__title a');
          if (link) link.focus();
        }
      });
    }

    function setOpen(open) {
      if (!panel || !toggle) return;
      panel.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    if (toggle) {
      toggle.addEventListener('click', function () {
        setOpen(!panel.classList.contains('is-open'));
      });
      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && panel.classList.contains('is-open') && toggle.offsetParent !== null) {
          setOpen(false);
          toggle.focus();
        }
      });
    }
    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        setOpen(false);
        if (bar) bar.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        heading.focus({ preventScroll: true });
      });
    }

    function updateProgress() {
      if (!track || !progress || !thumb) return;
      var max = track.scrollWidth - track.clientWidth;
      var overflow = max > 2;
      progress.hidden = !overflow;
      if (!overflow) return;
      var size = track.clientWidth / track.scrollWidth;
      var pos = track.scrollLeft / max;
      thumb.style.width = (size * 100) + '%';
      thumb.style.left = (pos * (1 - size) * 100) + '%';
    }

    if (track && progress && thumb) {
      var dragging = false;
      var startX = 0;
      var startScroll = 0;

      function ratio() {
        var free = progress.clientWidth - thumb.offsetWidth;
        return free > 0 ? (track.scrollWidth - track.clientWidth) / free : 0;
      }

      progress.addEventListener('pointerdown', function (e) {
        if (e.button !== 0) return;
        if (e.target !== thumb) {
          var rect = progress.getBoundingClientRect();
          var target = (e.clientX - rect.left - thumb.offsetWidth / 2) * ratio();
          track.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
          return;
        }
        dragging = true;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        progress.classList.add('is-dragging');
        track.classList.add('is-dragging');
        progress.setPointerCapture(e.pointerId);
        e.preventDefault();
      });
      progress.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        track.scrollLeft = startScroll + (e.clientX - startX) * ratio();
      });
      function endDrag() {
        if (!dragging) return;
        dragging = false;
        progress.classList.remove('is-dragging');
        track.classList.remove('is-dragging');
      }
      progress.addEventListener('pointerup', endDrag);
      progress.addEventListener('pointercancel', endDrag);

      track.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress);
      updateProgress();
    }

    function onSet(e) {
      if (!root.isConnected) { window.removeEventListener('vm-blog:set', onSet); return; }
      var d = e.detail || {};
      if (d.group === 'q') state.q = String(d.value || '').trim();
      else if (d.group === 'sort') state.sort = d.value || 'newest';
      else if (GROUPS.indexOf(d.group) > -1) state[d.group] = Array.isArray(d.value) ? d.value.slice() : (d.value ? [d.value] : []);
      else return;
      update();
    }
    window.addEventListener('vm-blog:set', onSet);

    var params = new URLSearchParams(window.location.search);
    GROUPS.forEach(function (g) {
      var v = params.get(g);
      if (v) state[g] = v.split(',').filter(Boolean);
    });
    if (params.get('q')) state.q = params.get('q');
    if (['newest', 'oldest', 'az'].indexOf(params.get('sort')) > -1) state.sort = params.get('sort');
    cfg.currentTags.forEach(function (tag) {
      var g = groupOf(tag);
      if (g && state[g].indexOf(tag) === -1) state[g].push(tag);
    });

    function fetchPage(p) {
      var url = cfg.base + (cfg.base.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(cfg.sectionId) + '&page=' + p;
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var r = doc.querySelector('[data-vm-blog-results]');
          return { pages: r ? parseInt(r.getAttribute('data-pages'), 10) || 1 : 1, nodes: doc.querySelectorAll('[data-vm-blog-item]') };
        })
        .catch(function () { return { pages: 1, nodes: [] }; });
    }
    function loadRest(from, total) {
      var last = Math.min(total, cfg.maxPages);
      var jobs = [];
      for (var p = from; p <= last; p++) jobs.push(fetchPage(p));
      if (!jobs.length) return Promise.resolve();
      return Promise.all(jobs).then(function (results) {
        results.forEach(function (res) { addItems(res.nodes); });
      });
    }
    function done() {
      root.removeAttribute('aria-busy');
      render();
    }

    root.setAttribute('aria-busy', 'true');
    if (cfg.currentTags.length) {
      list.innerHTML = '';
      fetchPage(1).then(function (first) {
        addItems(first.nodes);
        render();
        writeUrl();
        return loadRest(2, first.pages);
      }).then(done);
    } else {
      addItems(list.querySelectorAll('[data-vm-blog-item]'));
      render();
      if (anyActive()) writeUrl();
      loadRest(2, cfg.pages).then(done);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-vm-blog-results]').forEach(init);
  }

  initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();